import { modelFromDto } from './roles.exports';

export class Controller {

    /** @ngInject */
    constructor($state, $uibModal, Alert) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
    }

    $onInit() {
        this.roles = this.roles
            .map((role) => modelFromDto(role, this.groups))
            .map((role) => ({...role, groups: role.groups.filter((group) => group.isSelected)}))
    }

    showRemoveModal(roleId) {
        this.$uibModal
            .open({
                component: 'companyManageApplicationRolesRemove',
                resolve: {
                    companyId: () => this.companyId,
                    appId: () => this.appId,
                    roleId: () => roleId,
                },
            }).result
            .then(() => {
                const index = this.roles.findIndex(({id}) => id === roleId);
                this.roles.splice(index, 1);
                this.$state.rolesEdited = true;
                this.Alert('success', 'company.manage-application.roles.remove.removed');
            })
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/roles/roles.controller.js